const product = {
  information: "Informatie", // translated
  additionalInformation: "Extra informatie", // translated
  contactUs: "Neem contact op", // translated
  contactUsText: "Wilt u uw reis op maat samenstellen of heeft u andere vragen?", // translated
  dropUsAnEmail: "Stuur ons een e-mail", // translated
  viewLess: "Bekijk minder", // translated
  viewMore: "Bekijk meer", // translated
  less: "minder", // translated
  more: "meer", // translated
  highlights: "Hoogtepunten", // translated
  inclusions: "insluitsels", // translated
  exclusions: "Uitsluitingen", // translated
  pleaseWait: "Even geduld aub...", // translated
  tourType: "Tourtype", // translated
  search: "Zoekopdracht", // translated
  available: "Beschikbaar", // translated
  availableTours: "Beschikbare rondleidingen", // translated
  sortBy: "SORTEER OP", // translated
  priceLowToHigh: "Prijs laag naar hoog", // translated
  priceHighToLow: "Prijs: hoog naar laag", // translated
  mostPopular: "Meest populair", // translated
  roomOnly: "Alleen kamer", // translated
  bedAndBreakfast: "Bed & Breakfast", // translated
  halfBoard: "Halfpension", // translated
  fullBoard: "Vol pension", // translated
  allInclusive: "All Inclusive", // translated
  viewDetails: "Details bekijken", // translated
  close: "Dichtbij", // translated
  at: "Bij", // translated
  person: "persoon", // translated
  cancellationPolicy: "Annuleringsvoorwaarden", // translated
  cancellationIs: "annulering is", // translated
  to: "tot", // translated
  bookingRemarks: "Opmerkingen bij boeking", // translated
  totalPrice: "Totale prijs", // translated
  back: "Rug", // translated
  bookNow: "Boek nu", // translated
  minutes: "Minuten", // translated
  visitDuration: "Bezoekduur", // translated
  itinerary: "Routebeschrijving", // translated
  airportToHotel: "Luchthaven naar hotel", // translated
  hotelToAirport: "Hotel naar luchthaven", // translated
  details: "details", // translated
  servicesDetails: "Dienstendetails", // translated
  services: "Diensten", // translated
  day: "Dag", // translated
  next: "Volgende", // translated
  nextStep: "Volgende stap", // translated
  skip: "Overslaan", // translated
  remarks: "Opmerkingen", // translated
  optional: "optioneel", // translated
  guests: "Gasten", // translated
  payment: "Betaling", // translated
  pickup: "Raap op", // translated
  featuredPackage: "Aanbevolen pakket", // translated
  flights: "Vluchten", // translated
  accommodation: "Accommodatie", // translated
  transfers: "Overboekingen", // translated
  tours: "Rondleidingen", // translated
  experiences: "Ervaringen", // translated
  featuredTour: "Aanbevolen tour", // translated
  From: "Van", // translated
  Accommodation: "Accommodatie", // translated
  approxDuration: "Ca. duur", // translated
  travellerInformation: "Reizigersinformatie", // translated
  bookingOverview: "Boekingsoverzicht", // translated
  checkout: "Uitchecken", // translated
  paymentFailed: "Betaling mislukt", // translated
  paymentSuccess: "Betaling gelukt", // translated
  night: "Nacht", // translated
  viewEscapes: "Bekijk Escape", // translated
  escapeType: "Ontsnappingstype", // translated
  adultsOnly: "Alleen volwassenen", // translated
  totalDuration: "Totale duur", // translated
  options: "Opties", // translated
  products: "Producten", // translated
  nights: "Nachten", // translated
  product: "Product", // translated
  departingAirport: "Vertrekkende luchthaven", // translated
  childrenAreNotAllowedInThisTour: "Kinderen zijn niet toegestaan op deze tour", // translated
  viewExperience: "Bekijk Ervaring", // translated
};

export default product;
